// Import the functions you need from the SDKs
import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';
import { getDatabase, Database } from 'firebase/database';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCq6QMjc1SZr3hLGWpxH-zlk2J85f3JFoA",
  authDomain: "kled-io.firebaseapp.com",
  databaseURL: "https://kled-io-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kled-io",
  storageBucket: "kled-io.firebasestorage.app",
  messagingSenderId: "1058675582183",
  appId: "1:1058675582183:web:bc22f457ab3561e07dae42",
  measurementId: "G-53TTL9HQSQ"
};

// Initialize Firebase
let firebaseApp: FirebaseApp | undefined;
let analytics: Analytics | undefined;
let db: Firestore | undefined;
let auth: Auth | undefined;
let rtdb: Database | undefined;

// This check prevents initialization errors when executing on the server side
if (typeof window !== 'undefined' && !getApps().length) {
  firebaseApp = initializeApp(firebaseConfig);
  
  // Only initialize analytics on the client
  analytics = getAnalytics(firebaseApp);
  
  // Initialize Firestore
  db = getFirestore(firebaseApp);
  
  // Initialize Authentication
  auth = getAuth(firebaseApp);
  
  // Initialize Realtime Database
  rtdb = getDatabase(firebaseApp);
} else if (getApps().length > 0) {
  // If already initialized, use that one
  firebaseApp = getApps()[0];
  db = getFirestore(firebaseApp);
  auth = getAuth(firebaseApp);
  rtdb = getDatabase(firebaseApp);
}

export { firebaseApp, analytics, db, auth, rtdb };
